import { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import useInit from './hooks/useInit'
import { tableColumnWidths, roles } from 'consts'
import {
  PagingState,
  SearchState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  SortingState,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
  PagingPanel,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import getPageSize from 'utils/getPageSize'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'
import { useParams } from 'react-router-dom'
import BackButton from 'shared/components/BackButton'
import { formatDateTime, stringToDateTime } from 'utils/dateUtils'

const FilterSyncLog: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [rows, setRows] = useState<any>([])
  const [filterName, setFilterName] = useState<string>('')

  const { id } = useParams()

  const { store } = useContext(ReactReduxContext)

  const columns: { name: string; title: string; encodeHtml?: boolean; getCellValue?: any }[] = [
    { name: 'created_at', title: 'Date' },
    { name: 'logAction', title: 'Action' },
    { name: 'count', title: 'Count' },
    { name: 'text', title: 'Description' },
    { name: 'action', title: 'Action' },
    
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'text', width: 'auto' },
    { columnName: 'logAction', width: '15rem' },
    { columnName: 'count', width: '5rem' },
    { columnName: 'created_at', width: tableColumnWidths.extended_action },
    { columnName: 'action', width: tableColumnWidths.action },
  ]

  const tableColumnExtensions: Array<Table.ColumnExtension> = [
    {columnName: 'text', wordWrapEnabled: true, width: 'auto'},
    {columnName: 'count', width: '10rem', align: 'right'}
  ]

  useInit({
    id,
    setRows,
    setFilterName,
    setShowOverlay,
  })

  const [textFormatter] = useState<any>({
    for: ['text'],
    formatterComponent: (props) => {
      if (props.row.status === 1) {
        return props.row.text
      }
      return <span className='text-danger'>{props.row.text}</span>
    },
    editorComponent: undefined,
    availableFilterOperations: undefined,
  })

  const [dateFormatter] = useState<any>({
    for: ['created_at'],
    formatterComponent: (props) => {
      return formatDateTime(stringToDateTime(props.row.created_at))
    },
    editorComponent: undefined,
    availableFilterOperations: undefined,
  })



  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className='small with-action min-mobile-width' />
  )
  const PagingContainer = (props) => {
    return <PagingPanel.Container {...props} className='table-footer' />
  }
  return (
    <Layout
    pageTitle={filterName !== '' ? `Sync Log - ${filterName}` : 'Sync Log'}
    footerContent={<Footer />}
    brandContent={getBrandContent()}
    headerInsert={<BackButton url='/filters' text='All Filters' />}
    
    showOverlay={showOverlay}
    menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <>
        <Grid rows={rows} columns={columns}>
          <DataTypeProvider {...textFormatter} />
          <DataTypeProvider {...dateFormatter} />
          <SortingState defaultSorting={[{ columnName: 'created_at', direction: 'desc' }, { columnName: 'id', direction: 'desc' }]} />
          <SearchState defaultValue='' />
          <IntegratedFiltering />
          <PagingState defaultCurrentPage={0} pageSize={getPageSize()} />
          <IntegratedSorting />
          <IntegratedPaging />
          <Toolbar />
          <SearchPanel />
          <Table tableComponent={TableComponent} columnExtensions={tableColumnExtensions} />
          <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
          <TableHeaderRow showSortingControls />
          <PagingPanel pageSizes={[]} containerComponent={PagingContainer} />
        </Grid>

      </>
    </Layout>
  )
}

export default FilterSyncLog
